import { defineMessages } from 'react-intl';

const messages = defineMessages({
  activateCarriers: {
    description: 'Wallet provider settings dropdown option - Wallet Registration',
    defaultMessage: 'Activate Carriers',
    id: 'b/y4Fy',
  },
  activateCarrierLong: {
    description: 'disabled checkbox tooltip message to indicate to users to activate carrier first',
    defaultMessage: 'Activate carrier to view rates and create labels.',
    id: 'XcYbza',
  },
  activateCarrierNoRate: {
    description: 'disabled checkbox tooltip message to indicate to users to activate carrier first',
    defaultMessage: 'Activate carrier to create labels.',
    id: 'sNNsOU',
  },
  activateCarrierBlocked: {
    description: 'disabled checkbox tooltip message to indicate a request is being processed',
    defaultMessage: '{providerName} services are pending approval.',
    id: '/422A2',
  },
  activateCarrierBlockedUnknown: {
    description: 'disabled checkbox tooltip message to indicate an unknown error occurred',
    defaultMessage: 'Error activating carrier. Please contact support.',
    id: '9HP7vs',
  },
  activateCarrier: {
    description: 'dropdown option to activate carrier for use',
    defaultMessage: 'Activate carrier',
    id: 'wa2fHT',
  },
  openSettings: {
    description: 'Wallet provider settings dropdown option - Account settings',
    defaultMessage: 'Carrier Settings',
    id: '6baBbL',
  },
  default: {
    description: 'message indicating the default account for a label provider',
    defaultMessage: 'Default',
    id: 'm8SWh/',
  },
  setAsDefault: {
    description: 'Wallet provider settings dropdown option - Set as Default',
    defaultMessage: 'Set as Default',
    id: 'i+7SEs',
  },
  walletDescription: {
    description: 'Setup Wallet description',
    defaultMessage: 'Manage carriers, postage and insurance from a shared balance with discounted rates. <link>Get started</link>',
    id: 'kvUwr6',
  },
  sectionSubheader: {
    description: 'Wallet section subheader text',
    defaultMessage: 'Shipping services set up, managed, and paid from your balance',
    id: 'VjPzym',
  },
  setUpCarriersButton: {
    description: 'Wallet set up carriers button',
    defaultMessage: 'Set up carriers',
    id: 'UHT5OA',
  },
  balanceLabel: {
    description: "text label for a provider's balance amount",
    defaultMessage: 'Balance: {balance}',
    id: 'Lv0gH5',
  },
  balanceSection: {
    description: 'Wallet Balance section',
    defaultMessage: '<bold>Balance</bold>: {balance}',
    id: 'bqxS7h',
  },
  addFundsLink: {
    description: 'Wallet add funds button',
    defaultMessage: 'Add Funds',
    id: 'b5ai0F',
  },
  updatePayment: {
    description: 'Wallet update payment method link',
    defaultMessage: 'Update payment method',
    id: 'f7/LVA',
  },
  changeNickname: {
    description: 'Wallet change nickname link',
    defaultMessage: 'Change nickname',
    id: 'aLlJHm',
  },
  manageAutoFunding: {
    description: 'Wallet manage auto-funding link',
    defaultMessage: 'Manage auto-funding',
    id: 'Oh76XT',
  },
  save: {
    description: 'Wallet save button',
    defaultMessage: 'Save',
    id: 'rjMfXO',
  },
  cancel: {
    description: 'Wallet cancel button',
    defaultMessage: 'Cancel',
    id: 'iFpMiv',
  },
  savingError: {
    description: 'Save ShipStations specific Carriers modal save error',
    defaultMessage: 'Unexpected error saving provider settings',
    id: '2R0sIQ',
  },
  walletSettings: {
    description: 'Wallet settings tooltip',
    defaultMessage: '{walletBrandName} Settings',
    id: '5G93rn',
  },
  walletUpdatePaymentMethodSuccessContent: {
    description: 'Content for notification for successfully updating payment info',
    defaultMessage:
      'The billing information for {walletBrandName} has been updated. If you also need to update billing information for your ShipStation subscription, go to the <link>Subscription Page</link>.',
    id: '9N2PSg',
  },
  viewReports: {
    description: 'Wallet settings dropdown option - View reports',
    defaultMessage: 'View reports',
    id: 'Z2jgeD',
  },
  manageServices: {
    description: 'Wallet provider settings dropdown option - Manage services',
    defaultMessage: 'Manage services',
    id: 'UZxBg4',
  },
  refreshServices: {
    description: 'Wallet provider settings dropdown option - Refresh services',
    defaultMessage: 'Refresh services',
    id: 'm7Cgei',
  },
  refreshServiceSuccess: {
    description: 'Success message after refreshing servie',
    defaultMessage: 'Services have been refreshed!',
    id: 'K7vpcI',
  },
  refreshServiceError: {
    description: 'Error message after refreshing servie',
    defaultMessage: 'Failed to refresh services. Please try again.',
    id: 'BSUpgO',
  },
  preferAccount: {
    description: 'Wallet provider settings dropdown option - Prefer this account',
    defaultMessage: 'Prefer this account',
    id: 'RZYKk9',
  },
  reauthorize: {
    description: 'Wallet provider settings dropdown option - Reauthorize',
    defaultMessage: 'Reauthorize',
    id: 'lc5DKN',
  },
  featuresHeader: {
    description: 'Header for features modal',
    defaultMessage: 'Features & Benefits',
    id: '+mPC96',
  },
  featuresModalCarrier: {
    description: 'Specifies the carrier for features modal',
    defaultMessage: '{carrier} from ShipStation',
    id: '8S+bQG',
  },
  tableHeaderFeatures: {
    description: 'Table header for shipStation carrier table',
    defaultMessage: 'Features & Benefits',
    id: 'oCjAtA',
  },
  tableHeaderCarrierId: {
    description: 'Table header for shipStation carrier table',
    defaultMessage: 'Carrier ID',
    id: 'WI/YBl',
  },
  carrierIdTooltip: {
    description: 'Tooltip content for Carrier ID for shipStation carrier table',
    defaultMessage: 'The unique code for referencing your carrier accounts when using the ShipStation API.',
    id: '/nfD4N',
  },
  copyCarrierIdButtonLabel: {
    defaultMessage: 'Copy Carrier Id',
    description: 'Label for the copy carrier Id',
    id: 'NN9ruR',
  },
  newPasswordLabel: {
    description: 'New password input field label',
    defaultMessage: 'New Password',
    id: '0ZQOQV',
  },
  confirmPasswordLabel: {
    description: 'Re-enter new password input field label',
    defaultMessage: 'Re-enter New Password',
    id: 'w0p6A0',
  },
  passwordsDoNotMatch: {
    description: 'Error message when both password fields do not match',
    defaultMessage: 'Please enter the same password.',
    id: 'baoixu',
  },
  updatePasswordError: {
    description: 'Generic message when updating password fails',
    defaultMessage: 'Failed to update password. Please try again.',
    id: 'I3kLuW',
  },
  walletUpdatePaymentMethodSuccessHeader: {
    description: 'Header for notification for successfully updating payment info',
    defaultMessage: 'Success',
    id: '9gc6nJ',
  },
  tableHeaderCarrier: {
    description: 'Table header for Wallet table',
    defaultMessage: 'Carrier',
    id: '/BzFkX',
  },
  tableHeaderPreferredAccount: {
    description: 'Table header for Wallet table',
    defaultMessage: 'Preferred Account',
    id: 'g+3Shb',
  },
  tableHeaderServices: {
    description: 'Table header for Wallet table',
    defaultMessage: 'Services',
    id: 'FVQkY7',
  },
  tableHeaderActions: {
    description: 'Table header for Wallet table',
    defaultMessage: 'Actions',
    id: 'ByhX9e',
  },
  missingProviderFallbackMessage: {
    description: 'Fallback message if provider information is missing',
    defaultMessage: 'Unknown Provider',
    id: 'wpRV3W',
  },
  viewBalanceHistory: {
    description: 'message for link to view balance history',
    defaultMessage: 'View Balance History',
    id: 'u0C21x',
  },
  additionalCarriers: {
    description: 'merchant own carrier accounts tab name',
    defaultMessage: 'Your Carrier Accounts',
    id: 'I0Y9My',
  },
  shipStationCarriers: {
    description: 'shipstation carriers tab name',
    defaultMessage: 'ShipStation Carriers',
    id: 'ruxPaL',
  },
  carriersTitle: {
    description: 'Title for the Carriers page',
    defaultMessage: 'Carriers',
    id: 'nsRv0q',
  },
  carriersDescription: {
    description: 'Description under Title for the Carriers Page',
    defaultMessage: "Save with ShipStation's carrier rates or bring your own carrier accounts.",
    id: 'wrWMO0',
  },
  subscriptionLink: {
    description: 'Instructions and a link for the user to manage their payments',
    defaultMessage: 'Need to manage payment methods? Go to the <link>Payment & Subscription settings</link>',
    id: '4ifqqO',
  },
  getStartedMessageText: {
    description: 'banner message text that calls out wallet registration benefits',
    defaultMessage: '<b>Activate Savings on Carrier Rates.</b> Complete setup to benefit from the best rates and services.',
    id: 'tOX0Hk',
  },
  newCarriersMessageText: {
    description: 'new carries available banner message ',
    defaultMessage: '<b>New carriers and services available.</b> Update to enable new carrier services and expanded functionality.',
    id: '4Uc6cq',
  },
  update: {
    description: 'update button label',
    defaultMessage: 'Update',
    id: 'MHpIml',
  },
  getStarted: {
    description: 'Call to action text for user to start wallet registration process',
    defaultMessage: 'Get Started',
    id: 'hTouZY',
  },
  deleteCarrier: {
    description: 'delete carrier dropdown label',
    defaultMessage: 'Delete Carrier',
    id: 'zJ7umg',
  },
  seeAllCarriers: {
    description: 'See All Carriers link text',
    defaultMessage: 'See All Carriers...',
    id: 'TlwbpY',
  },
  byoaHeader: {
    description: 'Connect Your Own Accounts header text',
    defaultMessage: 'Connect Your Own Carrier Accounts',
    id: 'ANWxN6',
  },
  byoaDescriptionLine1: {
    description: 'line one of description above carrier grid',
    defaultMessage: 'Your preferred carrier not already available? Have a negotiated rate?',
    id: '7zVBAy',
  },
  byoaDescriptionLine2: {
    description: 'line two of description above carrier grid',
    defaultMessage: 'Add your own accounts with almost any carrier out there.',
    id: '2U2DSb',
  },
  andMore: {
    description: 'the and more link that opens the features modal',
    defaultMessage: ', and <link>more...</link>',
    id: 'wQ2JU8',
  },
  trialNonWalletAccess: {
    description: 'message to show when nonwallet provider eligibility is activated during trial',
    defaultMessage:
      "You've activated the Your Carriers feature. During your free trial you may use this feature without cost. Once you pick a paid subscription plan, there is an extra monthly fee to access this feature.",
    id: 'd9alY2',
  },
  activatedNonWalletAccess: {
    description: 'message to show when nonwallet provider eligibility is activated',
    defaultMessage:
      "You've activated the Your Carriers feature for an additional monthly fee. If you'd like to remove the Your Carriers feature, you can do so from the <link>Payment & Subscription page</link>.",
    id: 'C8bxak',
  },
  pendingInactiveNonWalletAccess: {
    description: 'message to show when nonwallet provider eligibility will soon be deactivated',
    defaultMessage:
      "You've deactivated the Your Carriers feature and will no longer have access to these carriers in ShipStation after {endDate}.",
    id: 'i+Sa+5',
  },
  pendingInactiveNonWalletAccessExcludingStamps: {
    description: 'message to show when nonwallet provider eligibility will soon be deactivated excluding stamps',
    defaultMessage:
      "You've deactivated the Your Carriers feature and will no longer have access to these carriers in ShipStation after {endDate}.{br}{br}The Your Carrier fee is waived for Stamps.com accounts.",
    id: 'uPY6G+',
  },
  inactiveNonWalletAccess: {
    description: 'message to show when nonwallet provider eligibility is deactivated',
    defaultMessage:
      "You've deactivated the Your Carriers feature and no longer have access to these carriers in ShipStation. <enableYourCarriersLink>Reactivate the Your Carriers feature</enableYourCarriersLink>",
    id: '0sOf0U',
  },
  inactiveNonWalletAccessExcludingStamps: {
    description: 'message to show when nonwallet provider eligibility is deactivated excluding stamps',
    defaultMessage:
      "You've deactivated the Your Carriers feature and no longer have access to these carriers in ShipStation. <enableYourCarriersLink>Reactivate the Your Carriers feature</enableYourCarriersLink>{br}{br}The Your Carrier fee is waived for Stamps.com accounts.",
    id: 'Tzq2px',
  },
  activateYourCarriers: {
    description: 'button call to action text to activate the feature for users to add their own carrier accounts',
    defaultMessage: 'Activate Your Carriers',
    id: 'AfUWB0',
  },
  yourCarrierFeeDisclaimer: {
    description: 'disclaimer that adding your own carrier account will incur an extra monthly cost',
    defaultMessage:
      'Using the Your Carriers will incur an additional {feeAmount}/mo fee on the {planName} subscription plan. This feature unlocks the ability to add as many of your own carrier accounts as you need.',
    id: '4iJR98',
  },
  contactAdmin: {
    description: 'Tooltip text asking to contact admin for permissions',
    defaultMessage: 'Please contact your account administrator to access this setting',
    id: 'jFr31k',
  },
  registrationFraudError: {
    description: 'Registration error message that is intentionally generic to prevent fraud',
    defaultMessage:
      'UPS failed to register your new UPS account ID. <supportLink>Contact support to confirm your account details.</supportLink>',
    id: 'Dm5r4V',
  },
  registrationAddressError: {
    description: 'Registration error related to a bad address with links to help fix the problem',
    defaultMessage:
      'UPS had a problem with your Payment Method address: "{error}". Review your <addressLink>payment info</addressLink>, then <updateLink>try again</updateLink>.',
    id: 'TuG2gA',
  },
  statusPending: {
    description: 'Status of a carrier account that is pending activation',
    defaultMessage: 'Pending approval',
    id: '1s9i7i',
  },
  statusPendingDate: {
    description: 'Date when carrier was connected',
    defaultMessage: 'Submitted {formattedDate}',
    id: 'R4hTul',
  },
  warningTagTooltipHeader: {
    description: 'Warning message header in the Tag tooltip',
    defaultMessage: 'Check your setup',
    id: 'KADZMZ',
  },
  warningTagTooltip: {
    description: 'Warning message in the Tag tooltip',
    defaultMessage:
      'It has been more than 5 working days since you submitted your registration. <supportLink>Contact support</supportLink> for more information.',
    id: 'QATPqb',
  },
  warningTagTooltipHover: {
    description: 'Warning message when you hover in the Tag tooltip',
    defaultMessage: 'You registered more than 5 working days ago.',
    id: 'HaaD1i',
  },
  pending: {
    description: 'message to show provider request is pending',
    defaultMessage: 'Pending',
    id: '1ycz/R',
  },
  emptyAdditionalCarrierTableMessage: {
    description: 'placeholder message for an empty table that should list the various carriers available',
    defaultMessage: 'Add a carrier to manage them here.',
    id: 'xARl+N',
  },
  upgradePromotionalBannerHeader: {
    description: 'Header message for the promotional banner that encourages users to upgrade their plan in order to see more rates',
    defaultMessage: 'Unlock improved rates with paid plans',
    id: 'OOB4sW',
  },
});

export default messages;
